import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import Axios from "axios";
import jwtDecode from "jwt-decode";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import PaypalLogo from "../../../Assets/Images//paypal.png";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import { url } from "../../../config/config";
import PayDialogBox from "./PayDialogBox/PayDialogBox";
import CustomerKhaltiPay from "../../../Component/KhaltiPay/CustomerKhaltiPay";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import { useStyles } from "./BuyBook.css";

class BuyBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      payType: "",
      emailVerified: false,
      book: [],
      changedCurrency: "",
      orderId: sessionStorage.getItem("orderId"),
    };
  }

  componentDidMount() {
    this.getBook(this.props.match.params.bookId);
    this.decodeToken(this.props.userToken);
  }

  decodeToken = async (userToken) => {
    try {
      const data = await jwtDecode(userToken);
      this.setState({
        emailVerified: data.isVerified,
      });
    } catch (error) {}
  };

  getCurrency = async () => {
    const response = await Axios.get(
      "https://api.exchangerate.host/convert?from=NPR&to=USD"
    );
    this.setState({
      changedCurrency:
        Math.round(this.state.book.price * response.data.result * 100) / 100,
    });
  };

  getBook = async (bookId) => {
    const response = await Axios.get(`${url}/api/books/${bookId}`);
    if (response.data.length !== 0) {
      this.setState({
        book: response.data,
      });
    }
  };

  handleDialogOpen = (type) => {
    if (type === "paypal") {
      this.getCurrency();
    }
    this.setState({
      dialogOpen: true,
      payType: type,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  render() {
    const { classes } = this.props;
    const { book, orderId } = this.state;
    return (
      <div>
        <Header />
        {book.length !== 0 ? (
          <div className={classes.root}>
            <div style={{ fontSize: 30 }}>Complete your transaction</div>
            <Divider />
            <div style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
                  <Paper className={classes.paper}>
                    <div>
                      <img
                        src={book.bookCoverUrl}
                        alt="bookCover"
                        className={classes.coverImageStyle}
                      />
                    </div>
                    <div>
                      <ListItem style={{ fontSize: 24, fontWeight: "bold" }}>
                        {book.title}
                      </ListItem>
                      <ListItem style={{ fontSize: 20, color: "grey" }}>
                        By {book.author.firstName} {book.author.lastName}
                      </ListItem>
                      <ListItem>Genre: {book.genre}</ListItem>
                      <ListItem
                        style={{
                          fontSize: 18,
                          color: "#0a1f3a",
                          fontWeight: "bold",
                        }}
                      >
                        Rs.{book.price} /-
                      </ListItem>
                    </div>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
                  <Paper style={{ padding: 20 }}>
                    <div style={{ fontSize: 24, fontWeight: "bold" }}>
                      Order Details
                    </div>
                    <div style={{ fontSize: 20, fontWeight: "bold" }}>
                      OrderId: {orderId}
                    </div>
                    <br />
                    <ListItem divider>
                      <b style={{ flexGrow: 1 }}>Unit Price:</b>
                      <div>Rs.{book.price} /-</div>
                    </ListItem>
                    <ListItem divider>
                      <b style={{ flexGrow: 1 }}>Total Price:</b>
                      <b>Rs.{book.price} /-</b>
                    </ListItem>
                    <div>
                      By completing your purchase, your agree to these
                      <Link to="/termsandcondition">Terms and Condition</Link>.
                    </div>
                  </Paper>
                </Grid>
              </Grid>
              <div
                style={{
                  paddingTop: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {this.props.isAuth === true &&
                  this.state.emailVerified === true && (
                    <div>
                      <p style={{ fontSize: 24 }}>Pay with</p>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <CustomerKhaltiPay
                          classes={classes.buttonStyle}
                          payType="khalti"
                          productIdentity={orderId}
                          productName={book.title}
                          // productUrl={`http://localhost:3000/book/buy/${book._id}`}
                          productUrl={`https://bookashram.netlify.app/book/buy/${book._id}`}
                          bookId={book._id}
                          total={book.price}
                          userToken={this.props.userToken}
                          reloadUrl={`/book/buy/${book._id}`}
                          itemDetails={[]}
                        />
                        <Button
                          className={classes.buttonStyle}
                          onClick={() => this.handleDialogOpen("paypal")}
                        >
                          <img
                            src={PaypalLogo}
                            alt="paypal"
                            style={{ width: 150, height: 70 }}
                          />
                        </Button>
                      </div>
                      <PayDialogBox
                        open={this.state.dialogOpen}
                        handleClose={this.handleDialogClose}
                        book={this.state.book}
                        payType={this.state.payType}
                        totalPrice={this.state.book.price}
                        changedCurrency={this.state.changedCurrency}
                      />
                    </div>
                  )}
              </div>
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {this.props.isAuth === true &&
                  this.state.emailVerified === false && (
                    <div style={{ fontSize: 20 }}>
                      You need to first verify your email address in order to
                      complete transaction.
                    </div>
                  )}
              </div>
            </div>
          </div>
        ) : (
          <CustomLoader />
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
    isAuth: state.UserReducer.isAuth,
  };
};

export default connect(mapStateToProps, null)(withStyles(useStyles)(BuyBook));
